// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import ScrollReveal from "components/ScrollReveal";

function Historia() {
  return (
    <MKBox component="section" className="school-mission" py={{ xs: 5, md: 7 }}>
      <Container>
        <ScrollReveal>
          <Grid
            container
            item
            xs={12}
            lg={9}
            spacing={3}
            sx={{
              mx: "auto",
              p: { xs: 2.5, md: 4 },
              borderRadius: "30px",
              background: "linear-gradient(135deg, rgba(255,255,255,0.82), rgba(255,244,226,0.72))",
              border: "1px solid rgba(255,255,255,0.78)",
              boxShadow: "inset 0 1px 0 rgba(255,255,255,0.6), 0 24px 70px rgba(24,34,54,0.08)",
            }}
          >
            <Grid item xs={12} md={12} textAlign="center">
              <MKTypography
                variant="h5"
                align="center"
                my={{ xs: 2, md: 3 }}
                color="dark"
                sx={{ lineHeight: 1.75, maxWidth: "58rem", mx: "auto" }}
              >
                La obra educativa se basa en la pedagogía del amor y de la Misericordia y manifiesta
                las aptitudes del Corazón de Cristo. El mensaje cristiano tiene que penetrar en la
                educación para que llegue a la mente, y a la práctica de la vida. El valor de la
                unicidad y originalidad de la persona exige una educación personalizada e integral.
              </MKTypography>
            </Grid>
            <Grid item xs={12} md={12} textAlign="center">
              <MKTypography
                variant="h5"
                align="center"
                my={{ xs: 2, md: 3 }}
                color="dark"
                sx={{ lineHeight: 1.75, maxWidth: "58rem", mx: "auto" }}
              >
                El respeto hacia todos, la acogida, la solidaridad y la reconciliación deben ser
                actitudes características del educador cabriniano, pues el testimonio es la fuerza
                estimuladora y operativo de la educación. Los programas educativos tienen que
                favorecer la sana ocupación del tiempo libre y de la diversión mediante iniciativas
                y actividades según las posibilidades y tradiciones locales.
              </MKTypography>
            </Grid>
          </Grid>
        </ScrollReveal>
      </Container>
    </MKBox>
  );
}

export default Historia;
